const routes = [
    {
        path: "/promotional/process/reports",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "promotionalprocess_index"
        },
    }
];

export default routes;
